module.exports = __webpack_public_path__ + "img/Alchimeia_island.2c0820b5.png";